import React from 'react';
// import Header1 from './Header1';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/system';
import header from './../../../assets/global/bg.png';
import Title from '../Title';
// import i18next from 'i18next';
const Header = ({ page_name, cover }) => {

    const themeM = useTheme();
    const isMobile = useMediaQuery(themeM.breakpoints.down('sm'));
    const location = useLocation();
    let page = location.pathname.split('/')[1];
    // let lng = i18next.language;
    return (
        <Box position={'relative'} sx={{ backgroundImage: `url(${cover || header})`, height: { md: '25rem', xs: '15rem' }, backgroundSize: 'cover', position: 'relative', display: 'flex', justifyContent: 'initial', alignItems: 'center', }} >
            <div className="overlay"></div>
            <Box sx={{ display: 'flex', justifyContent: 'center', position: 'relative', zIndex: 3, alignItems: 'center', px: { md: 10, xs: 2 } }} >
                <Title title={` ${page_name || page}`} isHr={true} variant={isMobile ? 'h6' : 'h4'} color={'primary.text'} fontWeight={500} />
            </Box>
        </Box>
    );
};

export default Header;
